import { createStore, combineReducers } from 'redux'

import { 
  discordServerReducer, 
  solanaNFTReducer, 
  newsArticlesReducer, 
  chatReportsReducer,
  duplicateNFTsReducer,
} from './reducers'

export const initStore = () => {
  /** REDUCERS *****/
  const reducers = combineReducers({
    solanaNFT: solanaNFTReducer,
    discordServer: discordServerReducer,
    chatReports: chatReportsReducer,
    newsArticles: newsArticlesReducer,
    duplicateNFTs: duplicateNFTsReducer,
  })

  /** STORE *****/
  const store = createStore(reducers)

  /** RUN SAGAS *****/
  return store
}
